import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import { Checkbox } from 'components/Form/SpecialButtons';

const GeneralForm = ({ element }) => (
	<div>
		<Field
			type='text'
			name='name'
			customlabel='Nom de la mutuelle'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			id='isPromoted'
			name='isPromoted'
			customlabel='Afficher cette mutuelle en haut de la liste'
			component={Checkbox}
		/>
	</div>
);

export default GeneralForm;
